import React from "react";
import { object, bool } from "prop-types";
import { Box, Typography } from "@mui/material";

import { formateDate } from "../../utils/date";
import ItemBadges from "../ItemBadges";
import HTMLContentBlock from "./HTMLContentBlock";

const RecentUpdatesListItem = ({ item, last }) => {
  if (!item) return null;
  return (
    <Box
      sx={{
        marginBottom: { xs: "30px", md: 0 },
        paddingBottom: { xs: 0, md: last ? 0 : "30px" },
        display: "block",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
      component="article"
    >
      <Box
        sx={{
          display: { xs: "block", md: "flex" },
          flexDirection: { md: "row" },
          gap: { md: 3 },
          alignItems: { md: "stretch" },
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Left Column: Date & Badges */}
        <Box
          sx={(theme) => ({
            position: "relative",
            display: { xs: "flex", md: "block" },
            flexDirection: { xs: "row", md: "column" },
            alignItems: { xs: "center", md: "flex-start" },
            gap: { xs: 1, md: 0 },
            width: { xs: "100%", md: "280px" },
            maxWidth: { xs: "100%", md: "280px" },
            flexShrink: { md: 0 },
            alignSelf: { md: "stretch" },
            marginBottom: { xs: theme.spacing(1), md: 0 },
            paddingRight: { md: "30px" },
          })}
        >
          <Box
            sx={{
              marginRight: { xs: 2.5, md: 0 },
            }}
          >
            <Typography
              variant="h2"
              sx={(theme) => ({
                color: theme.palette.primary.main,
                fontSize: "24px",
                lineHeight: "24px",
                fontWeight: "bold",
                marginBottom: 0,
                [theme.breakpoints.up("md")]: {
                  marginBottom: theme.spacing(1),
                  fontSize: "26px",
                  lineHeight: "26px",
                },
              })}
            >
              {formateDate(item.display_date, { format: "m d, Y" })}
            </Typography>
          </Box>
          <ItemBadges item={item} positioned={false} size="small" />
          {/* Separator */}
          <Box
            sx={(theme) => ({
              position: "absolute",
              right: 5,
              top: 10,
              bottom: last ? 0 : "-30px",
              width: 12,
              maxWidth: "12px",
              display: { xs: "none", md: "block" },
              overflow: "visible",
              pointerEvents: "none",
              "&::before": {
                content: "''",
                display: "block",
                position: "absolute",
                height: 12,
                width: 12,
                maxWidth: "12px",
                top: 0,
                left: 0,
                background: theme.palette.primary.main,
                borderRadius: "50%",
                border: "1px solid white",
                zIndex: 3,
              },
              "&::after": {
                content: "''",
                display: "block",
                position: "absolute",
                width: "1px",
                maxWidth: "1px",
                top: "12px",
                left: "5.5px",
                bottom: last ? "-1px" : "-90px",
                background: last
                  ? `linear-gradient(to bottom, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 60%, transparent 100%)`
                  : theme.palette.primary.main,
                zIndex: 2,
              },
            })}
          ></Box>
        </Box>

        {/* Right Column: Content */}
        <Box
          sx={{
            display: "block",
            width: { xs: "100%", md: "auto" },
            maxWidth: { xs: "100%", md: "none" },
            flex: { md: "1 1 auto" },
            minWidth: { md: 0 },
            boxSizing: "border-box",
            overflow: "hidden",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            wordBreak: "break-word",
          }}
        >
          <HTMLContentBlock dirtyHTML={item.body_html} attachments={item.attachments} />
        </Box>
      </Box>
    </Box>
  );
};

RecentUpdatesListItem.propTypes = {
  item: object,
  last: bool,
};

export default RecentUpdatesListItem;
